
/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/core'

const style = css`
  display: block;
  font-size: 14px;
  line-height: 1.86;
  letter-spacing: -0.2px;
`

const Label = props => {
  return (
    <label css={style} {...props}>
      {props.children}
    </label>
  )
}

export default Label